import { gql } from '@apollo/client';

export const PROPERTY_CHECKLISTPOINTS_FRAGMENT = gql`
  fragment PropertyChecklistpoints on Property {
    checklistpoints {
      info {
        teaser
      }
    }
  }
`;
